if (!customElements.get('notify-me-modal')) {
  customElements.define(
    'notify-me-modal',
    class NotifyMeModal extends ModalDialog {
      constructor() {
        super();
        this.form = this.querySelector('.notify-me-modal__form');
        this.submitButton = this.form.querySelector('[type="submit"]');
        this.successMessage = this.querySelector('.notify-me-modal__message--success');
        this.errorMessage = this.querySelector('.notify-me-modal__message--error');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      show(opener) {
        this.form.reset();
        this.form.hidden = false;
        this.successMessage.hidden = true;
        this.errorMessage.hidden = true;

        if (opener && opener.dataset.variantId) {
          this.form.elements.variant.value = opener.dataset.variantId;
          this.querySelector('.notify-me-modal__title').textContent = opener.dataset.productTitle;
        }

        super.show(opener);
      }

      onSubmitHandler(event) {
        event.preventDefault();

        this.submitButton.setAttribute('disabled', 'disabled');
        this.errorMessage.hidden = true;

        fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.dataset.companyId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: '2024-10-15',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: this.form.elements.email.value },
                  },
                },
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${this.form.elements.variant.value}`,
                  },
                },
              },
            },
          }),
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Klaviyo responded with status ${response.status}`);
            this.form.hidden = true;
            this.successMessage.hidden = false;
          })
          .catch(() => {
            this.errorMessage.hidden = false;
          })
          .finally(() => {
            this.submitButton.removeAttribute('disabled');
          });
      }
    }
  );
}
